<template lang="pug">
  header(:class="[{ stickyHeader: lastScroll > 100}, stickyMenuClass, stickyHeaderClass]")
    .header-top
      a(class="tel" href="tel:004921529946028")
        font-awesome-icon(icon="phone")
        | 02152 / 994 602 8
    .header-middle
      component(:is="logoWrap" v-bind="logoWrapProps")
          img.logo(v-if="webpSupport" src="~@/assets/img/ercklentz_logo.webp", width="360", height="73", :alt="CMS.name")
          img.logo(v-else src="~@/assets/img/ercklentz_logo.png", width="360", height="73", :alt="CMS.name")
    .header-bottom
        .container.mx-auto
            .socialmedia
                a(href="https://www.instagram.com/ercklentz.kempen/" target="_blank" rel="noopener" alt="Instagram" title="Instagram")
                    font-awesome-icon.icon-fb(:icon="['fab', 'instagram']")
                a(href="https://www.facebook.com/RestaurantErcklentz" target="_blank" rel="noopener" alt="Facebook" title="Facebook")
                    font-awesome-icon.icon-fb(:icon="['fab', 'facebook-f']")
            Menu#main-menu(k="main-menu", :max-depth="3")
            .mobile
                button.hamburger.hamburger--3dy(
                    type="button",
                    aria-label="Menu",
                    id="hamburgerMenu",
                    :class="{ 'is-active': sidebar || stickyMenuClass }",
                    @click="toggleSidebar"
                  )
                    span.hamburger-box
                        span.hamburger-inner
                a(class="tel" href="tel:004921529946028")
                    font-awesome-icon(icon="phone")
                    | 02152 / 994 602 8


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Menu from '@/components/Menu.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: '',
        stickyMenuClass: ''
    }),
    components: {
        Menu
    },
    computed: {
        logoWrap() {
            let tag = 'span';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        ...mapGetters({
            CMS: 'CMS',
            menus: 'menus',
            sidebar: 'sidebar',
            webpSupport: 'webpSupport'
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },
        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
                if(window.innerWidth > 1024) {
                  this.stickyMenuClass = ''
                }
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
                if(window.innerWidth > 1024) {
                  this.stickyMenuClass = 'open'
                }
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  .header-top
    @apply text-center p-1 hidden
    @screen sm
        @apply block
    background-color: $color-primary
    @screen lg
        @apply p-3
    .tel > .svg-inline--fa
      @apply mr-2
      transform: scaleX(-1)
  .header-middle
    @apply flex justify-center my-6
    @screen sm
        @apply my-8
    @screen lg
        @apply my-12
    .logo
        @apply w-full
        max-width: 230px
        @screen sm
            max-width: 280px
        @screen lg
            max-width: 360px
  .header-bottom
    @apply p-2
    @screen sm
        @apply p-3
    background-color: $color-primary
    > .container
        @screen lg
            @apply relative
    .socialmedia
        @apply absolute hidden
        @screen sm
            @apply block
        right: 20px
        top: 3px
        @screen lg
            top: 0
        a > .svg-inline--fa
            @apply ml-2
            &:hover
                @apply opacity-75
    .mobile
        @apply flex justify-between items-center
        @screen sm
            @apply hidden
        .hamburger
            @apply p-0
            margin-top: 4px
        .tel > .svg-inline--fa
            @apply mr-2
            transform: scaleX(-1)
    #main-menu
        @apply hidden
        @screen sm
            @apply block
        &::v-deep
          ul
            @apply flex justify-between mx-auto
            max-width: 800px
            &.tree-menu
              & > li
                @apply relative
                &.active > .tree-item a
                  @apply font-semibold
                & > .tree-item a
                  @apply flex uppercase justify-between transition duration-300 ease-linear
                  &:hover
                    @apply font-semibold


</style>
